import { Popover as PopoverPrimitive } from "@base-ui/react/popover";
import { cn } from "@bidbattles/bloks/lib/ui";
import type * as React from "react";

const createPopoverHandle = PopoverPrimitive.createHandle;
type RootChangeEventDetails = PopoverPrimitive.Root.ChangeEventDetails;
type PopoverHandle<Payload> = PopoverPrimitive.Handle<Payload>;

function Popover<Payload>({ ...props }: PopoverPrimitive.Root.Props<Payload>) {
	return <PopoverPrimitive.Root {...props} />;
}

function PopoverTrigger<Payload>({
	...props
}: PopoverPrimitive.Trigger.Props<Payload>) {
	return <PopoverPrimitive.Trigger {...props} />;
}

function PopoverContent({
	className,
	align = "center",
	sideOffset = 4,
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Popup> &
	Pick<
		React.ComponentProps<typeof PopoverPrimitive.Positioner>,
		"sideOffset" | "align"
	>) {
	return (
		<PopoverPrimitive.Portal>
			<PopoverPrimitive.Positioner sideOffset={sideOffset} align={align}>
				<PopoverPrimitive.Popup
					className={cn(
						"origin-[var(--transform-origin)] rounded-lg bg-[canvas] text-gray-900 shadow-lg shadow-gray-300 outline-1 outline-gray-300 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0",
						className,
					)}
					{...props}
				/>
			</PopoverPrimitive.Positioner>
		</PopoverPrimitive.Portal>
	);
}

function PopoverTitle({
	className,
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Title>) {
	return (
		<PopoverPrimitive.Title
			{...props}
			className={cn("font-semibold text-sm text-gray-900", className)}
		/>
	);
}

function PopoverDescription({
	className,
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Title>) {
	return (
		<PopoverPrimitive.Description
			{...props}
			className={cn("text-xs text-gray-500", className)}
		/>
	);
}

function PopoverAction({
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Close>) {
	return <PopoverPrimitive.Close {...props} />;
}

export {
	type RootChangeEventDetails,
	type PopoverHandle,
	createPopoverHandle,
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverTitle,
	PopoverDescription,
	PopoverAction,
};
